import { render, staticRenderFns } from "./AccountAppealBlack.vue?vue&type=template&id=80b7f500&scoped=true&"
import script from "./AccountAppealBlack.vue?vue&type=script&lang=js&"
export * from "./AccountAppealBlack.vue?vue&type=script&lang=js&"
import style0 from "./AccountAppealBlack.vue?vue&type=style&index=0&id=80b7f500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7f500",
  null
  
)

export default component.exports